import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const EMICalculator = () => {
  const [loanAmount, setLoanAmount] = React.useState(100000);
  const [interestRate, setInterestRate] = React.useState(12);
  const [loanTenure, setLoanTenure] = React.useState(12);

  const monthlyRate = interestRate / 12 / 100;

  const emi =
    (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, loanTenure)) /
    (Math.pow(1 + monthlyRate, loanTenure) - 1);

  const totalPayment = emi * loanTenure;
  const totalInterest = totalPayment - loanAmount;

  const chartData = [
    { name: "Principal", value: Number(loanAmount.toFixed(2)) },
    { name: "Interest", value: Number(totalInterest.toFixed(2)) },
  ];
  

  const COLORS = ["#4E56C0", "#D78FEE"];

  return (
    <div
      className="mt-5 mb-5 p-4"
      style={{
        background: "#F7F9FC",
        borderRadius: "20px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
      }}
    >
      <h3 className="fw-bold text-center mb-4">
        Personal Loan EMI Calculator – ShubhPaisa
      </h3>

      <div className="row">
        <div className="col-md-6 mb-4">
          <label className="fw-semibold">Loan Amount (₹)</label>
          <input
            type="range"
            className="form-range"
            min="10000"
            max="500000"
            step="1000"
            value={loanAmount}
            onChange={(e) => setLoanAmount(Number(e.target.value))}
          />
          <div className="d-flex justify-content-between">
            <span>₹10,000</span>
            <span>₹5,00,000</span>
          </div>
          <div className="fw-bold mt-1">₹{loanAmount}</div>

          <label className="fw-semibold mt-4">Interest Rate (%)</label>
          <input
            type="range"
            className="form-range"
            min="10"
            max="30"
            step="0.5"
            value={interestRate}
            onChange={(e) => setInterestRate(Number(e.target.value))}
          />
          <div className="d-flex justify-content-between">
            <span>10%</span>
            <span>30%</span>
          </div>
          <div className="fw-bold mt-1">{interestRate}%</div>

          <label className="fw-semibold mt-4">Tenure (Months)</label>
          <input
            type="range"
            className="form-range"
            min="6"
            max="60"
            step="1"
            value={loanTenure}
            onChange={(e) => setLoanTenure(Number(e.target.value))}
          />
          <div className="d-flex justify-content-between">
            <span>6 Months</span>
            <span>60 Months</span>
          </div>
          <div className="fw-bold mt-1">{loanTenure} Months</div>
        </div>

        <div className="col-md-1"></div>

        <div className="col-md-5 d-flex flex-column align-items-center">
          <div
            style={{
              background: "white",
              borderRadius: "18px",
              padding: "25px",
              width: "100%",
              boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
            }}
          >
            <h5 className="fw-bold text-center mb-3">Your EMI Details</h5>

            <div className="d-flex justify-content-between my-2">
              <span>Total Loan Amount</span>
              <strong>₹{loanAmount}</strong>
            </div>

            <div className="d-flex justify-content-between my-2">
              <span>Total Interest Payable</span>
              <strong>₹{totalInterest.toFixed(2)}</strong>
            </div>

            <div className="d-flex justify-content-between my-2">
              <span>Total Amount Payable</span>
              <strong>₹{totalPayment.toFixed(2)}</strong>
            </div>

            <hr />

            <h4 className="text-center fw-bold text-primary">
              ₹{emi.toFixed(2)} <small>/ month</small>
            </h4>

            <p className="text-center mt-2" style={{ fontSize: "0.9rem" }}>
              This is an estimated EMI. Final EMI may vary after verification.
            </p>

            <div style={{ height: "180px" }}>
              <ResponsiveContainer>
                <PieChart>
                  <Pie
                    data={chartData}
                    dataKey="value"
                    nameKey="name"
                    outerRadius={70}
                    label
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={index} fill={COLORS[index]} />
                    ))}
                  </Pie>
                  <Tooltip formatter={(value) => value.toFixed(2)} />

                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EMICalculator;
